import { OGProperties, PageTags } from '../types';
import { RoutesPaths } from '@router/constants';

const title = 'Press Kit'
const url = window.location.origin + RoutesPaths.PRESS_KIT

export const pressKit: PageTags = {
  title: `| ${title}`,
  url: url,
  properties: [
    {
      property: OGProperties.title,
      content: `FireStarter | ${title}`,
    },
    {
      property: OGProperties.description,
      content: 'Download our press assets here',
    },
    {
      property: OGProperties.url,
      content: url,
    },
  ]
}
